import BusinessSlides from './BusinessSlides';

export default class {
  constructor() {

    const BusinessSlidesDom = document.querySelectorAll('[data-js="business-slide"]');
    if (BusinessSlidesDom) {
      [...BusinessSlidesDom].forEach((el) => {
        new BusinessSlides(el);
      })
    }
  }
}
